<template>
  <div id="login">
    <div class="box z-depth-15">
      <div class="tr"><img src="https://prepclass.com.ng/img/logo.png" class="img-fluid mb-2 mt-2" /></div>
      <slot></slot>
      <div class="hide">
        <a :href="twitterURL" class="btn social waves-effect waves-primary z-depth-0 google white">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px" x="0px" y="0px" viewBox="0 0 112.197 112.197" style="enable-background:new 0 0 112.197 112.197;" xml:space="preserve"><g><circle style="fill:#55ACEE;" cx="56.099" cy="56.098" r="56.098"/><g><path style="fill:#F1F2F2;" d="M90.461,40.316c-2.404,1.066-4.99,1.787-7.702,2.109c2.769-1.659,4.894-4.284,5.897-7.417 c-2.591,1.537-5.462,2.652-8.515,3.253c-2.446-2.605-5.931-4.233-9.79-4.233c-7.404,0-13.409,6.005-13.409,13.409 c0,1.051,0.119,2.074,0.349,3.056c-11.144-0.559-21.025-5.897-27.639-14.012c-1.154,1.98-1.816,4.285-1.816,6.742 c0,4.651,2.369,8.757,5.965,11.161c-2.197-0.069-4.266-0.672-6.073-1.679c-0.001,0.057-0.001,0.114-0.001,0.17 c0,6.497,4.624,11.916,10.757,13.147c-1.124,0.308-2.311,0.471-3.532,0.471c-0.866,0-1.705-0.083-2.523-0.239 c1.706,5.326,6.657,9.203,12.526,9.312c-4.59,3.597-10.371,5.74-16.655,5.74c-1.08,0-2.15-0.063-3.197-0.188 c5.931,3.806,12.981,6.025,20.553,6.025c24.664,0,38.152-20.432,38.152-38.153c0-0.581-0.013-1.16-0.039-1.734 C86.391,45.366,88.664,43.005,90.461,40.316L90.461,40.316z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
          <span class="social-title">Connect with Twitter</span>
        </a>
        <a :href="facebookURL" class="btn social waves-effect waves-primary z-depth-0 google white">
          <svg height="18" width="18" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 408.788 408.788" style="enable-background:new 0 0 408.788 408.788;" xml:space="preserve"><path style="fill:#475993;" d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085 h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882 v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955 l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087 c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085 C408.786,24.662,384.124,0,353.701,0z" /><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
          <span class="social-title">Connect with Facebook</span>
        </a>
        <a :href="linkedinURL" class="btn social waves-effect waves-primary z-depth-0 google white">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #0277b4">
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
          <span class="social-title">Connect with LinkedIn</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "auth-index",
  data() {
    return {
      linkedinURL: BASE_API + "/v1/tutor/linkedin/redirect",
      facebookURL: BASE_API + "/v1/tutor/facebook/redirect",
        twitterURL: BASE_API + "/v1/tutor/twitter/redirect"
    };
  }
};
</script>

<style lang="scss" scoped>
#login {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    231.71deg,
    rgb(95, 152, 99) 13.27%,
    rgba(95, 152, 99, 0.69) 60.4%,
    rgba(95, 152, 99, 0.39) 99.73%
  );

  .box {
    padding: 16px;
    border-radius: 7px;
    background-color: white;

    div.tr {
      width: 65%;
      margin-left: auto;
      margin-right: auto;
    }
    h4.tr {
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      text-transform: capitalize;
      font-family: "Product Sans", sans-serif;
      letter-spacing: 2px;
      margin-bottom: 0;
    }
    p {
      max-width: 330px;
      text-align: center;

      &.tagline {
        font-weight: 500;
        font-size: 13px;
        color: #000000;
        opacity: 0.5;
        text-align: center;
        margin-top: 7px;
      }
      &.mr {
        margin: 25px 0;
        font-weight: 500;
        color: #a3a3a3;
      }
    }
    div.alert {
      width: 330px;
    }
    div.input {
      position: relative;

      input,
      select {
        margin: 25px 0 0 0;
        padding: 0 16px;
        border-radius: 5px;
        border: 1px solid #ecf0f3;
        background: #fcfcfd;
        box-sizing: border-box;
        width: 330px;
        height: 53px;
        outline-color: #35b2f9;
        font-size: 14px;
        font-family: "Product Sans", sans-serif;
        color: #454749;
      }
      .abs {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(25%);
      }

      button,
      a.social {
        margin: 25px 0 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        box-sizing: border-box;
        width: 330px;
        height: 53px;
        font-size: 14px;
        font-family: "Product Sans", sans-serif;
        text-transform: uppercase;
        font-weight: 500;
      }
    }

    a.google {
      margin-bottom: 15px;
      padding: 0 16px;
      border-radius: 3px;
      box-sizing: border-box;
      width: 330px;
      height: 53px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 14px;
      font-family: "Product Sans", sans-serif;
      font-weight: 500;
      color: #a3a3a3;
      text-transform: none;
      border: 1px solid #ecf0f3;

      svg {
        margin-right: 10px;
      }
    }
  }
}
.btn,
.btn-flat {
  border: none;
  outline: none !important;
  border-radius: 3px;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
  text-transform: uppercase;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent; // Gets rid of tap active state
}
z-depth-15 {
  box-shadow: 0 2px 2px 0 hsla(0, 0%, 59%, 0.1),
    0 3px 1px -2px hsla(0, 0%, 59%, 0.1), 0 1px 5px 0 hsla(0, 0%, 59%, 0.1);
}
.primary {
  background-color: rgb(95, 152, 99);
}
.primary-text {
  color: rgb(95, 152, 99);
}
.white {
  background-color: #ffffff;
}
.white-text {
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Auth/AuthIndex.vue